import { ISite } from "../models/site.model";

export default function getSiteMetadata(site: ISite): ISite['siteMetadata'] {
    return site.siteMetadata;
}